export default __webpack_public_path__ + "static/allbends-5d91efd0fcadfdf45479caf85407106b.png";